import {
  acquireTokenAsync
} from "./auth";
import { resolveApiErrorMessage } from './api-error-message';
import { fetchResponseHandler } from './fetch-response-handler';

export async function fetchApi(url, method, body) {
  const tokenResponse = await acquireTokenAsync();
  const options = {
    credentials: "include",
    method: method,
    body: body,
  };
  if (tokenResponse) {
    options.headers = new Headers({ 'Authorization': 'Bearer ' + tokenResponse.accessToken });
  }

  let response;
  try {
    response = await fetch(url, options);
  } finally {
    const { responseBody } = await fetchResponseHandler({ response });
    return responseBody;
  }
}

// Like fetchApi, but rejects on a non-success status instead of swallowing it. Use for writes whose
// failure must be surfaced to the caller (e.g. immediate-CRUD saves that need to know whether to
// refetch/refresh). fetchResponseHandler still raises the user-facing toast; this adds the throw so
// the orchestrating code can branch.
export async function fetchApiOrThrow(url, method, body) {
  const tokenResponse = await acquireTokenAsync();
  const options = {
    credentials: "include",
    method: method,
    body: body,
  };
  if (tokenResponse) {
    options.headers = new Headers({ 'Authorization': 'Bearer ' + tokenResponse.accessToken });
  }

  const response = await fetch(url, options);
  const { responseBody, responseStatus } = await fetchResponseHandler({ response });
  if (responseStatus >= 400) {
    throw new Error(resolveApiErrorMessage({ status: responseStatus, body: responseBody }));
  }
  return responseBody;
}


